'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var PooledSeasonalityReviewCalendarController = function PooledSeasonalityReviewCalendarController($scope, $state, pooledReviewCalendarService, featureToggleService, seasonalityReviewConstants, seasonalityConstants, momentService, searchCriteriaService, pooledSeasonalityDataCacheService) {
  $scope.seasonalityType = seasonalityConstants.SEASONALITY_TYPE.POOLED;
  $scope.screenState = {
    selectedTab: seasonalityReviewConstants.INDEX_ANALYSIS.VALUE,
    flowType: determineFlowType(),
    displayedMarket: $scope.calendarData.market,
    screenId: $scope.screen,
    spos: 'Default'
  };
  var market = $scope.calendarData.market.split('-');
  $scope.cabinClassGroups = pooledReviewCalendarService.getCabinClassGroups($scope.calendarData.market);
  $scope.cabins = pooledReviewCalendarService.getCabins($scope.cabinClassGroups);
  $scope.rtps = [];
  $scope.dowGroups = pooledReviewCalendarService.getDowGroups();
  $scope.checkDefaultFilters = function () {
    if ($scope.demandTransparencyAttributes) {
      $scope.defaultFilters = {
        selectedCabin: $scope.demandTransparencyAttributes.selectedCabin,
        selectedClassGroup: $scope.demandTransparencyAttributes.selectedClassGroup,
        selectedRtp: $scope.demandTransparencyAttributes.selectedRtp,
        selectedDow: $scope.demandTransparencyAttributes.selectedDow,
        significantPOS: $scope.demandTransparencyAttributes.significantPOS,
        contextData: $scope.demandTransparencyAttributes.contextData
      };
      $scope.screenState.spos = $scope.demandTransparencyAttributes.significantPOS;
    }
  };
  $scope.checkDefaultFilters();
  function setUpLabelsParams(maxRtp) {
    $scope.calendarData.spos = $scope.screenState.spos;
    $scope.calendarData.flowType = $scope.screenState.flowType;
    $scope.calendarData.maxRtp = maxRtp;
    $scope.calendarData.cabin = $scope.defaultFilters ? $scope.defaultFilters.selectedCabin : $scope.cabins[0];
    $scope.calendarData.dowGroup = $scope.defaultFilters ? $scope.defaultFilters.selectedDow : $scope.dowGroups[0];
  }
  $scope.flowTypeChange = function (event, data) {
    $scope.calendarData.flowType = _.capitalize(data.val[0]);
  };
  pooledReviewCalendarService.getMarketRTP(market[0], market[1]).then(function (data) {
    $scope.rtps = data;
    var maxRtp = _.maxBy(data, function (rtp) {
      return parseInt(rtp);
    }).toString();
    setUpLabelsParams(maxRtp);
  })["catch"](function (e) {
    toastr.error('Error occured while retrieving profile data', e);
  });
  $scope.analysisTabs = [{
    label: seasonalityReviewConstants.INDEX_ANALYSIS.LABEL,
    value: seasonalityReviewConstants.INDEX_ANALYSIS.VALUE,
    selected: true
  }, {
    label: seasonalityReviewConstants.SEASON_LABELS.LABEL,
    value: seasonalityReviewConstants.SEASON_LABELS.VALUE
  }];
  $scope.seasonalityButtonAvailable = function () {
    return $scope.screenState.screenId !== seasonalityReviewConstants.SCREEN_ID_SEASONALITY;
  };
  $scope.navigateToSeasonality = function () {
    var searchCriteria = searchCriteriaService.demandTransparencyToSeasonality([$scope.calendarData.market]);
    $state.go('app.seasonality', {
      transitionData: {
        timestamp: momentService.now(momentService.FIELD.EVENT_TIME_STAMP),
        searchCriteria: searchCriteria
      }
    });
  };
  function determineFlowType() {
    if ($scope.demandTransparencyAttributes && $scope.demandTransparencyAttributes.selectedFlowType) {
      return $scope.demandTransparencyAttributes.selectedFlowType;
    }
    return featureToggleService.isEnabled(seasonalityReviewConstants.FEATURE_MAPPED_MODE) ? seasonalityReviewConstants.FLOW_TYPE.REGULAR : seasonalityReviewConstants.FLOW_TYPE.MAPPED;
  }
  $scope.$on('$stateChangeStart', function () {
    pooledSeasonalityDataCacheService.invalidate();
  });
  $scope.isDemandSeasonality = function () {
    return true;
  };
};
PooledSeasonalityReviewCalendarController.$inject = ['$scope', '$state', 'PooledReviewCalendarService', 'FeatureToggleService', 'PooledSeasonalityReviewConstants', 'SeasonalityConstants', 'MomentService', 'TransitionSearchCriteriaService', 'PooledSeasonalityDataCacheService'];
module.exports = PooledSeasonalityReviewCalendarController;